// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sYfW2","header":"styles_header__KQAs9","body":"styles_body__ZmM9l","earth":"styles_earth__s6kLf","countries":"styles_countries__UJfIS"};